var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictogramComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M0 .35h51.753v51.573H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    opacity: 0.3,
    mask: "url(#B)",
    d: "M1.375 26.177H34.56V34l-33.184-.005zm33.81 18.646h16l-.805 5.725h-14.44z",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M1.375 27.553H34.56v6.442H4.84a3.47 3.47 0 0 1-3.464-3.464v-2.978zM4.84 1.725h34.62c1.9.002 3.46 1.55 3.462 3.463v16.885h-4.5c-2.125.003-3.848 1.725-3.85 3.85v.253H1.375V5.188a3.47 3.47 0 0 1 3.464-3.463zM50.375 25.8H35.938a2.48 2.48 0 0 1 2.472-2.344h9.493a2.48 2.48 0 0 1 2.473 2.344zm-2.473 24.757H38.4a2.48 2.48 0 0 1-2.476-2.476v-2.476H50.38v2.476a2.48 2.48 0 0 1-2.477 2.476zM35.934 27.165H50.38V44.22H35.933l.001-17.055zM4.84 35.368h16.62v7.524h-7.887c-.38 0-.687.308-.687.688s.308.687.687.687h17.644c.38 0 .687-.308.687-.687a.69.69 0 0 0-.687-.688h-8.383v-7.524H34.56v12.704c.002 2.125 1.725 3.848 3.85 3.85h9.493c2.125-.003 3.85-1.726 3.85-3.85V25.924c-.001-2.126-1.724-3.848-3.85-3.85h-3.607V5.188C44.292 2.517 42.128.353 39.458.35H4.84C2.168.353.002 2.517-.001 5.188V30.53c.003 2.67 2.168 4.834 4.84 4.837zm39.78 12.017h-2.926c-.38 0-.687.308-.687.687a.69.69 0 0 0 .687.688h2.926c.38 0 .687-.308.687-.688s-.308-.687-.687-.687M23.386 9.626H6.144c-.476 0-.862-.327-.862-.73s.386-.73.862-.73h17.242c.477 0 .862.325.862.73s-.385.73-.862.73m-8.743 5.054h-8.5c-.47 0-.853-.327-.853-.73s.38-.73.853-.73h8.5c.47 0 .852.327.852.73s-.38.73-.852.73",
    mask: "url(#B)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramComputer);
export default __webpack_public_path__ + "static/media/pictogram-computer.93b63efb09d7936caf5779ca54b440ca.svg";
export { ForwardRef as ReactComponent };